import { render, staticRenderFns } from "./wysiwyg.vue?vue&type=template&id=f99a4562&scoped=true&"
import script from "./wysiwyg.vue?vue&type=script&lang=js&"
export * from "./wysiwyg.vue?vue&type=script&lang=js&"
import style0 from "./wysiwyg.vue?vue&type=style&index=0&id=f99a4562&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f99a4562",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VCardTitle,VDialog,VFileInput,VIcon,VTextField})
